/*
 * <comparison-slider>: before/after image comparison driven by a range input.
 * Markup: .comparison-slider__overlay (clipped "before" image), .comparison-slider__line (handle),
 * input.comparison-slider__input (0–100), .comparison-slider__underlay ("after" image).
 */
class ComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.comparison-slider__input');
    this.overlay = this.querySelector('.comparison-slider__overlay');
    this.line = this.querySelector('.comparison-slider__line');
    if (!this.input) return;
    this.input.addEventListener('input', () => this.update());
    this.input.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    const value = Math.min(100, Math.max(0, parseFloat(this.input.value) || 0));
    this.style.setProperty('--position', `${value}%`);
    if (this.overlay) this.overlay.style.width = `${value}%`;
    if (this.line) this.line.style.left = `${value}%`;
  }
}

if (!customElements.get('comparison-slider')) customElements.define('comparison-slider', ComparisonSlider);
